import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { Nav } from "@/components/Nav";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductPage from "@/pages/ProductPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Studio from "@/pages/Studio";
import MediaKit from "@/pages/MediaKit";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const NavGate = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/studio")) return null;
  return <Nav />;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ smoothWheel: true, lerp: 0.09 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <NavGate />
          <CartDrawer />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:lookupKey" element={<ProductPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/studio" element={<Studio />} />
            <Route path="/studio/assets" element={<MediaKit />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" toastOptions={{ style: { borderRadius: 0, background: "#050505", color: "#fff", border: "1px solid #333" } }} />
      </CartProvider>
    </div>
  );
}

export default App;
